import React, { useEffect, useState } from 'react';
import { 
  Container, Typography, TextField, Button, IconButton, Box, Alert, Tooltip, 
  Modal, FormControlLabel, Switch, Table, TableBody, TableCell, TableContainer, 
  TableHead, TableRow, Paper, Chip
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ptBR } from 'date-fns/locale';
import api from '../axios';
import ModuleHeader from '../components/ModuleHeader';

function Professores() {
  const [bairro, setBairro] = useState('');
  const [cep, setCep] = useState('');
  const [editBairro, setEditBairro] = useState('');
  const [editCep, setEditCep] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const [professores, setProfessores] = useState([]);
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState('');
  const [editId, setEditId] = useState(null);
  const [editNome, setEditNome] = useState('');
  const [editEmail, setEditEmail] = useState('');
  const [telefoneWhatsapp, setTelefoneWhatsapp] = useState('');
  const [funcao, setFuncao] = useState('');
  const [endereco, setEndereco] = useState('');
  const [dataNascimento, setDataNascimento] = useState(null);
  const [editTelefoneWhatsapp, setEditTelefoneWhatsapp] = useState('');
  const [editFuncao, setEditFuncao] = useState('');
  const [editEndereco, setEditEndereco] = useState('');
  const [editDataNascimento, setEditDataNascimento] = useState(null);
  const [eMonitor, setEMonitor] = useState(false);
  const [editEMonitor, setEditEMonitor] = useState(false);

  const fetchProfessores = async () => {
    const res = await api.get('/professores/');
    setProfessores(res.data);
  };

  useEffect(() => {
    fetchProfessores();
  }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    setErro(''); setSucesso('');
    if (!nome || !email) {
      setErro('Preencha nome e e-mail');
      return;
    }
    try {
      await api.post('/professores/', {
        nome,
        email,
        telefone_whatsapp: telefoneWhatsapp,
        funcao,
        endereco,
        bairro,
        cep,
        data_nascimento: dataNascimento instanceof Date && !isNaN(dataNascimento) ? dataNascimento.toISOString().slice(0, 10) : '',
        e_monitor: eMonitor
      });
      setNome(''); setEmail(''); setTelefoneWhatsapp(''); setFuncao(''); setEndereco(''); setBairro(''); setCep(''); setDataNascimento(''); setEMonitor(false);
      setSucesso('Professor cadastrado!');
      fetchProfessores();
    } catch {
      setErro('Erro de conexão');
    }
  };

  const handleDelete = async (id) => {
    await api.delete(`/professores/${id}`);
    fetchProfessores();
  };

  const handleEdit = (id) => {
    const prof = professores.find(p => p.id === id);
    setEditId(id);
    setEditNome(prof.nome);
    setEditEmail(prof.email);
    setEditTelefoneWhatsapp(prof.telefone_whatsapp || '');
    setEditFuncao(prof.funcao || '');
    setEditEndereco(prof.endereco || '');
    setEditBairro(prof.bairro || '');
    setEditCep(prof.cep || '');
    setEditDataNascimento(prof.data_nascimento ? new Date(prof.data_nascimento) : null);
    setEditEMonitor(prof.e_monitor || false);
    setErro('');
    setSucesso('');
  };

  const handleCancelEdit = () => {
    setEditId(null);
    setEditNome('');
    setEditEmail('');
    setEditTelefoneWhatsapp('');
    setEditFuncao('');
    setEditEndereco('');
    setEditBairro('');
    setEditCep('');
    setEditDataNascimento('');
  };

  const handleSaveEdit = async (id) => {
    setErro(''); setSucesso('');
    if (!editNome || !editEmail) {
      setErro('Preencha nome e e-mail');
      return;
    }
    try {
      await api.put(`/professores/${id}`, {
        nome: editNome,
        email: editEmail,
        telefone_whatsapp: editTelefoneWhatsapp,
        funcao: editFuncao,
        endereco: editEndereco,
        bairro: editBairro,
        cep: editCep,
        data_nascimento: editDataNascimento instanceof Date && !isNaN(editDataNascimento) ? editDataNascimento.toISOString().slice(0, 10) : '',
        e_monitor: editEMonitor
      });
      setSucesso('Professor atualizado!');
      setEditId(null);
      fetchProfessores();
    } catch {
      setErro('Erro de conexão');
    }
  };

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, md: 2 } }}>
      <ModuleHeader module="Start" title="Professores" />
      <Button variant="contained" color="primary" sx={{ mb: 2 }} onClick={() => setOpenModal(true)} startIcon={<AddIcon />}>
        Novo
      </Button>
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: { xs: 2, sm: 4 }, borderRadius: 2, minWidth: { xs: '90vw', sm: 320 }, maxWidth: 800, maxHeight: '90vh', overflowY: 'auto' }}>
          <Typography variant="h6" gutterBottom>Cadastrar Professor</Typography>
          <Box component="form" onSubmit={(e) => { handleAdd(e); if (!erro) setOpenModal(false); }} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField label="Nome" value={nome} onChange={e => setNome(e.target.value)} fullWidth size="small" />
            <TextField label="E-mail" value={email} onChange={e => setEmail(e.target.value)} fullWidth size="small" />
            <TextField label="Whatsapp" value={telefoneWhatsapp} onChange={e => setTelefoneWhatsapp(e.target.value)} fullWidth size="small" />
            <TextField label="Função" value={funcao} onChange={e => setFuncao(e.target.value)} fullWidth size="small" />
            <TextField label="Endereço" value={endereco} onChange={e => setEndereco(e.target.value)} fullWidth size="small" />
            <TextField label="Bairro" value={bairro} onChange={e => setBairro(e.target.value)} fullWidth size="small" />
            <TextField label="CEP" value={cep} onChange={e => setCep(e.target.value)} fullWidth size="small" />
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
              <DatePicker
                label="Data de nascimento"
                value={dataNascimento}
                onChange={setDataNascimento}
                inputFormat="dd/MM/yyyy"
                renderInput={(params) => <TextField {...params} fullWidth size="small" />} 
              />
            </LocalizationProvider>
            <FormControlLabel
              control={
                <Switch
                  checked={eMonitor}
                  onChange={(e) => setEMonitor(e.target.checked)}
                  color="primary"
                />
              }
              label="É Monitor?"
            />
            <Button type="submit" variant="contained" sx={{ minWidth: 120, height: 40 }} startIcon={<SaveIcon />}>Cadastrar</Button>
          </Box>
        </Box>
      </Modal>
      {erro && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {typeof erro === 'string' ? erro : JSON.stringify(erro)}
        </Alert>
      )}
      {sucesso && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {typeof sucesso === 'string' ? sucesso : JSON.stringify(sucesso)}
        </Alert>
      )}
      
      <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
        <Table sx={{ minWidth: 650 }} size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>Nome</TableCell>
              <TableCell sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>E-mail</TableCell>
              <TableCell sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>WhatsApp</TableCell>
              <TableCell sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>Endereço</TableCell>
              <TableCell sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>Bairro</TableCell>
              <TableCell sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>CEP</TableCell>
              <TableCell sx={{ fontWeight: 'bold', whiteSpace: 'nowrap', textAlign: 'center' }}>Monitor</TableCell>
              <TableCell sx={{ fontWeight: 'bold', whiteSpace: 'nowrap', textAlign: 'center' }}>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {professores.map((prof) => (
              <TableRow 
                key={prof.id} 
                sx={{ 
                  '&:hover': { bgcolor: 'action.hover' },
                  '&:last-child td, &:last-child th': { border: 0 }
                }}
              >
                <TableCell component="th" scope="row">
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    {prof.nome}
                  </Typography>
                  {prof.funcao && (
                    <Typography variant="caption" color="text.secondary">
                      {prof.funcao}
                    </Typography>
                  )}
                </TableCell>
                <TableCell>
                  <Typography variant="body2">{prof.email}</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">{prof.telefone_whatsapp || '-'}</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2" sx={{ maxWidth: 200 }}>
                    {prof.endereco || '-'}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">{prof.bairro || '-'}</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">{prof.cep || '-'}</Typography>
                </TableCell>
                <TableCell align="center">
                  {prof.e_monitor && (
                    <Chip 
                      icon={<CheckCircleIcon />} 
                      label="Monitor" 
                      color="success" 
                      size="small"
                    />
                  )}
                </TableCell>
                <TableCell align="center">
                  <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'center' }}>
                    <Tooltip title="Editar">
                      <IconButton 
                        size="small" 
                        color="info"
                        onClick={() => handleEdit(prof.id)}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Excluir">
                      <IconButton 
                        size="small" 
                        color="error"
                        onClick={() => handleDelete(prof.id)}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Modal de Edição */}
      <Modal open={editId !== null} onClose={handleCancelEdit}>
        <Box sx={{ 
          position: 'absolute', 
          top: '50%', 
          left: '50%', 
          transform: 'translate(-50%, -50%)', 
          bgcolor: 'background.paper', 
          boxShadow: 24, 
          p: 4, 
          borderRadius: 2, 
          minWidth: 320, 
          maxWidth: 600,
          maxHeight: '90vh',
          overflowY: 'auto'
        }}>
          <Typography variant="h6" gutterBottom>Editar Professor</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField label="Nome" value={editNome} onChange={e => setEditNome(e.target.value)} size="small" fullWidth />
            <TextField label="E-mail" value={editEmail} onChange={e => setEditEmail(e.target.value)} size="small" fullWidth />
            <TextField label="Whatsapp" value={editTelefoneWhatsapp} onChange={e => setEditTelefoneWhatsapp(e.target.value)} size="small" fullWidth />
            <TextField label="Função" value={editFuncao} onChange={e => setEditFuncao(e.target.value)} size="small" fullWidth />
            <TextField label="Endereço" value={editEndereco} onChange={e => setEditEndereco(e.target.value)} size="small" fullWidth />
            <TextField label="Bairro" value={editBairro} onChange={e => setEditBairro(e.target.value)} size="small" fullWidth />
            <TextField label="CEP" value={editCep} onChange={e => setEditCep(e.target.value)} size="small" fullWidth />
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
              <DatePicker
                label="Data de nascimento"
                value={editDataNascimento}
                onChange={setEditDataNascimento}
                inputFormat="dd/MM/yyyy"
                renderInput={(params) => <TextField {...params} fullWidth size="small" />} 
              />
            </LocalizationProvider>
            <FormControlLabel
              control={
                <Switch
                  checked={editEMonitor}
                  onChange={(e) => setEditEMonitor(e.target.checked)}
                  color="primary"
                />
              }
              label="É Monitor?"
            />
            <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
              <Button 
                variant="contained" 
                color="success" 
                onClick={() => handleSaveEdit(editId)} 
                startIcon={<SaveIcon />}
                fullWidth
              >
                Salvar
              </Button>
              <Button 
                variant="outlined" 
                color="inherit" 
                onClick={handleCancelEdit} 
                startIcon={<CloseIcon />}
                fullWidth
              >
                Cancelar
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
}

function ProfessoresPageWrapper(props) {
  return <Professores {...props} />;
}

export default ProfessoresPageWrapper;
